import { ChannelSlot } from "@/includes/types/Slots.types";

import moment from "moment/moment";

export function formatPostSlotTime(slot: ChannelSlot) {
    return moment(`${ slot.date } ${ slot.slot.time }`).format('LLL')
}